(function () {
  'use strict';

  function getSelector(button) {
    return button.closest('[data-quantity-selector]');
  }

  function getInput(selector) {
    return selector ? selector.querySelector('[data-quantity-input]') : null;
  }

  function normalizeNumber(value, fallback) {
    var n = parseInt(value, 10);
    return Number.isFinite(n) ? n : fallback;
  }

  function updateMinusState(selector, value, increment) {
    var wrapper = selector.querySelector('[data-button-wrapper-minus]');
    if (!wrapper) return;
    if (value <= increment) {
      wrapper.classList.add('quantity-selector__button-wrapper--disabled');
    } else {
      wrapper.classList.remove('quantity-selector__button-wrapper--disabled');
    }
  }

  function setQuantity(button, direction) {
    var selector = getSelector(button);
    var input = getInput(selector);
    if (!selector || !input) return;

    var increment = normalizeNumber(input.getAttribute('data-increment-value'), 1);
    if (increment < 1) increment = 1;

    var min = normalizeNumber(input.getAttribute('min'), increment);
    var maxAttr = input.getAttribute('max');
    var max = maxAttr ? normalizeNumber(maxAttr, null) : null;
    var current = normalizeNumber(input.value, min);
    var next = current + (direction * increment);

    if (next < min) next = min;
    if (max !== null && next > max) next = max;

    input.value = next;
    updateMinusState(selector, next, increment);

    // Notify Shopify/theme code of the new value.
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // Capture phase intentionally takes control before any broken theme handler.
  document.addEventListener('click', function (event) {
    var plus = event.target.closest('[data-quantity-plus]');
    var minus = event.target.closest('[data-quantity-minus]');

    if (!plus && !minus) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    setQuantity(plus || minus, plus ? 1 : -1);
  }, true);

  // Keep minus-button styling correct when a customer types a quantity manually.
  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-quantity-input]')) return;
    var input = event.target;
    var selector = input.closest('[data-quantity-selector]');
    if (!selector) return;

    var increment = normalizeNumber(input.getAttribute('data-increment-value'), 1);
    var min = normalizeNumber(input.getAttribute('min'), increment);
    var current = normalizeNumber(input.value, min);
    if (current < min) {
      current = min;
      input.value = current;
    }
    updateMinusState(selector, current, increment);
  });
})();
